import {
  NEXT_PAGE_ACTION,
  PREV_PAGE_ACTION,
  GO_TO_PAGE_ACTION,
  IS_LOADING_ACTION,
  SEARCH_ACTION,
  SORT_ACTION,
  SET_DATA_ACTION,
  SET_ERROR_ACTION,
  SET_PAGE_SIZE_ACTION,
} from './constants';
import {
  DataSourceStatePayload,
  NextPageAction,
  PrevPageAction,
  GoToPageAction,
  IsLoadingAction,
  SearchAction,
  SortAction,
  SetDataAction,
  SetErrorAction,
  SetPageSizeAction,
  SortDefinition,
} from '../types';

export const nextPage = (): NextPageAction => ({ type: NEXT_PAGE_ACTION });
export const prevPage = (): PrevPageAction => ({ type: PREV_PAGE_ACTION });
export const goToPage = (pageNumber: number): GoToPageAction => ({
  type: GO_TO_PAGE_ACTION,
  payload: pageNumber,
});
export const setSearch = (search: string): SearchAction => ({
  type: SEARCH_ACTION,
  payload: search,
});
export const setSortBy = (sort: SortDefinition): SortAction => ({
  type: SORT_ACTION,
  payload: sort,
});
export const setIsLoading = (isLoading: boolean): IsLoadingAction => ({
  type: IS_LOADING_ACTION,
  payload: isLoading,
});
export const setData = (data: DataSourceStatePayload): SetDataAction => ({
  type: SET_DATA_ACTION,
  payload: data,
});
export const setError = (error: any): SetErrorAction => ({
  type: SET_ERROR_ACTION,
  payload: error,
  error: true,
});
export const setPageSize = (pageSize: number): SetPageSizeAction => ({
  type: SET_PAGE_SIZE_ACTION,
  payload: pageSize,
});
